import { render, staticRenderFns } from "./TitleWithButtons.vue?vue&type=template&id=2fa40c38"
import script from "./TitleWithButtons.vue?vue&type=script&lang=js"
export * from "./TitleWithButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports